export default __webpack_public_path__ + "static/media/ctc.50192768.svg";